import React from "react";
import "./Hero.css";

const Hero: React.FC = () => {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="hero">
      <div className="hero__bg">
        <div className="hero__grid" />
        <div className="hero__glow" />
      </div>
      <div className="hero__container">
        <h1 className="hero__title">
          We Find the Talent
          <br />
          <span className="hero__title--accent">That Moves You Forward</span>
        </h1>
        <p className="hero__subtitle">
          We take the time to understand your business, culture, and goals — so
          every candidate we bring is the right fit, not just a resume match.
        </p>
        <div className="hero__actions">
          <button className="hero__cta" onClick={scrollToContact}>
            Hire Top Talent Now
            <span className="hero__cta-arrow">→</span>
          </button>
          <button
            className="hero__cta-secondary"
            onClick={() =>
              document
                .getElementById("services")
                ?.scrollIntoView({ behavior: "smooth" })
            }
          >
            See Our Services
          </button>
        </div>
        <div className="hero__trust">
          <span className="hero__trust-label">Personal approach</span>
          <span className="hero__trust-divider">|</span>
          <span className="hero__trust-label">Pre-vetted candidates</span>
          <span className="hero__trust-divider">|</span>
          <span className="hero__trust-label">Transparent process</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
